import type { CSSProperties } from "react";

/** Wrap `<Tabs.List>` in `<Box w="100%" style={NAV_TABS_FULL_WIDTH_LINE_STYLE}>` so the rule spans the full row. */
export const NAV_TABS_FULL_WIDTH_LINE_STYLE: CSSProperties = {
  borderBottom: "2px solid #04305c",
};

/** Apply to each `<Tabs.Tab>` `style` so columns match the widest tab. */
export const NAV_TAB_EQUAL_WIDTH_CELL_STYLE: CSSProperties = {
  width: "100%",
  minWidth: 0,
  justifyContent: "center",
};

/**
 * `Tabs.List` `styles`: shrink-wrapped row where every tab column matches the widest label.
 * @param columnCount Number of `<Tabs.Tab>` children in the list
 * @param listOverrides Optional extra styles for the list element (e.g. flexShrink, padding)
 */
export function navTabsListStyles(columnCount: number, listOverrides?: CSSProperties) {
  return {
    list: {
      display: "inline-grid" as const,
      gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
      width: "max-content" as const,
      maxWidth: "100%",
      alignItems: "end" as const,
      boxShadow: "none" as const,
      gap: 0,
      ...listOverrides,
    },
  };
}

export const NAV_TAB_LABEL_FZ = "md" as const;

/** Segment index hint for stacked tabs; first/last use the same top radius as desktop. */
export type NavyNavTabStackSlot = "first" | "middle" | "last";

const NAV_TAB_RADIUS = "var(--mantine-radius-md)";

/** Navy / pale profile tabs: top-rounded segments (same in a stacked mobile column unless `middle`). */
export function navyProfileNavTabBorderRadius(isStacked: boolean, slot: NavyNavTabStackSlot): string {
  const topOnly = `${NAV_TAB_RADIUS} ${NAV_TAB_RADIUS} 0 0`;
  if (isStacked && slot === "middle") return "0";
  return topOnly;
}
